import { render, staticRenderFns } from "./MilitaryStatusTypeForm.vue?vue&type=template&id=299a80d0&"
import script from "./MilitaryStatusTypeForm.vue?vue&type=script&lang=js&"
export * from "./MilitaryStatusTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports